import React, { useContext } from "react";
import { Grid } from "@mui/material";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { GlobalContext } from "../../Utils/Contexts";
import TimeEditor from "../inputs/timeEditor";
import { saveTicketChanges } from "../../Utils/TicketDatabase";

export default function DurationTimes(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);

    return (
        <Grid item container xs={12} sm={6} alignItems={"top"} spacing={1} paddingTop={1} marginBottom={-1}>
            <Grid item xs={6}>
                <TimeEditor
                    sourceId={props.ticket.id}
                    sourceProperty="up_time"
                    labelText="FIRST UP TIME"
                    isRequired={true}
                    initialValue={props.ticket.up_time}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/legs"}
                    documentDate={props.ticket.date}
                />
            </Grid>
            <Grid item xs={6}>
                <TimeEditor
                    sourceId={props.ticket.id}
                    sourceProperty="down_time"
                    labelText="LAST DOWN TIME"
                    isRequired={true}
                    initialValue={props.ticket.down_time}
                    mergeChanges={(ticketId, values) => {
                        saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                    }}
                    isDisabled={props.isReadOnly}
                    errors={props.errors}
                    containerUrl={"ticket/legs"}
                    documentDate={props.ticket.date}
                />
            </Grid>
        </Grid>
    );
}
